import { Invoice } from '@/interfaces/invoice';
import { EntityResource } from './entity.resource';

/**
 * Resource faktur
 *
 * @export
 * @class InvoiceResource
 * @extends {EntityResource<Invoice>}
 */
export class InvoiceResource extends EntityResource<Invoice> {
  public getFields = {
    id: true,
    number: true,
    price: true,
    priceToPay: true
  };

  public listFields = {
    id: true,
    number: true,
    price: true,
    priceToPay: true,
    created: true
  };

  public listVariables = { filters: 'EntityFilters' };

  constructor() {
    super({
      entityName: 'invoice'
    });
  }
}

export const invoiceResource = new InvoiceResource();
